import AxiosClient from "../../../services/axios.services";

class NotificationTypeServices {
  getNotificationType = (params) =>
    AxiosClient.get(
      "/api/app/notificacion_tipo_correo/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getNotificationTypeByID = (id) =>
    AxiosClient.get(
      `/api/app/notificacion_tipo_correo/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveNotificationType = (data) =>
    AxiosClient.post(
      "/api/app/notificacion_tipo_correo/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editNotificationType = (id, data) =>
    AxiosClient.put(
      `/api/app/notificacion_tipo_correo/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteNotificationType = (id) =>
    AxiosClient.delete(
      `/api/app/notificacion_tipo_correo/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new NotificationTypeServices();
